var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filter-mobile",
      attrs: { id: "mobile-categories-menu" },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
          ) {
            return null
          }
          return _vm.checkFocusInside.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "buttons-wrapper" },
        [
          _c(
            "button",
            {
              ref: "filterButton",
              staticClass: "filter-mobile__btn btn",
              class: { "btn--bg": _vm.hasActiveFilters },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openFilterLayer.apply(null, arguments)
                }
              }
            },
            [
              _c("span", { staticClass: "filter-mobile__btn-label" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.i18n("Filtration")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("FunnelIcon", {
                staticClass: "icon funnel",
                attrs: { width: "26", height: "20" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeLayer === "filter"
            ? _c(
                "LayoutOverlay",
                {
                  staticClass: "filter-mobile__overlay",
                  attrs: {
                    "is-open": _vm.activeLayer === "filter",
                    triggerDataFilterName: _vm.triggerDataFilterName,
                    title: "Filtry"
                  },
                  on: {
                    close: _vm.closeFlitersLayer,
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      return _vm.closeFlitersLayer.apply(null, arguments)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button",
                        fn: function() {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn--small clear",
                                on: { click: _vm.cleanFilters }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.i18n("Clear filters")) +
                                    "\n                    "
                                ),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Usuń filtr")
                                ]),
                                _vm._v(" "),
                                _c("CloseIcon", {
                                  attrs: { width: "20", "aria-hidden": "true" }
                                })
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1303484579
                  )
                },
                [
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "ul",
                      { staticClass: "filters-active" },
                      [
                        _vm._l(_vm.getFiltersActive, function(
                          filterGroup,
                          filterName
                        ) {
                          return _vm._l(filterGroup, function(filter, index) {
                            return _c("li", { key: filterName + "-" + index }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "filters-active__button btn btn--small",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeFilter({
                                        key: filterName,
                                        values: [filter.value]
                                      })
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        filter.label || filter.filter_name
                                      ) +
                                      "\n                                "
                                  ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Usuń filtr")
                                  ]),
                                  _vm._v(" "),
                                  _c("CloseIcon", {
                                    attrs: {
                                      width: "20",
                                      "aria-hidden": "true"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          })
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm.filters
                    ? _c("FilterList", {
                        attrs: {
                          filters: _vm.filters,
                          titleDisplay: false,
                          triggerDataFilterName: _vm.triggerDataFilterName
                        },
                        on: { activeFiltersCount: _vm.setActiveFiltersCount }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "filter-mobile__apply" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--small apply-button",
                        staticStyle: { "flex-grow": "5" },
                        attrs: { "aria-label": "Anuluj" },
                        on: { click: _vm.closeFlitersLayer }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.i18n("Anuluj")) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("button", {
                      staticClass: "btn btn--block btn--bg apply-button",
                      staticStyle: { "flex-grow": "2" },
                      attrs: { "aria-label": "Zastosuj filtry" },
                      domProps: { textContent: _vm._s(_vm.applyButtonDisplay) },
                      on: { click: _vm.applyFilters }
                    })
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "CatalogSort",
            {
              staticClass: "filter-mobile__btn",
              attrs: { "button-only": "" },
              nativeOn: {
                click: function($event) {
                  _vm.activeLayer = "sort"
                }
              }
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.i18n("Sorting")) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "filter-mobile__btn btn",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.activeLayer = "categories"
                }
              }
            },
            [
              _c("span", { staticClass: "filter-mobile__btn-label" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.i18n("Category")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("SortIcon", {
                staticClass: "icon arrow",
                attrs: { width: "9", height: "10" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.activeLayer === "sort"
        ? _c(
            "LayoutOverlay",
            {
              staticClass: "filter-mobile__overlay",
              attrs: { "is-open": _vm.activeLayer === "sort", title: "Sortuj" },
              on: {
                close: function($event) {
                  _vm.activeLayer = null
                },
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.closeLayer.apply(null, arguments)
                }
              }
            },
            [
              _c("CatalogSortMobile", {
                on: { mobileCloseSort: _vm.mobileCloseSortCallback }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeLayer === "categories"
        ? _c(
            "LayoutOverlay",
            {
              ref: "focusTrapContainer",
              staticClass: "filter-mobile__overlay-background",
              attrs: {
                "is-open": _vm.activeLayer === "categories",
                "return-button-visible": false,
                tabindex: "-1"
              },
              on: {
                close: function($event) {
                  _vm.activeLayer = null
                },
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.closeLayer.apply(null, arguments)
                }
              }
            },
            [
              [
                _c("div", { staticClass: "categories-wrapper" }, [
                  _c("div", { staticClass: "categories-header" }, [
                    _c("div", { staticClass: "categories-header__wrapper" }, [
                      !_vm.isMainCategory
                        ? _c(
                            "div",
                            {
                              staticClass: "back-button",
                              attrs: { tabindex: "0", "aria-label": "Powrót" },
                              on: {
                                click: function($event) {
                                  return _vm.goBack(_vm.currentCategory)
                                },
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.goBack(_vm.currentCategory)
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return _vm.goBack(_vm.currentCategory)
                                  }
                                ]
                              }
                            },
                            [
                              _c("ArrowIcon", {
                                attrs: { width: "16", "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "title",
                        domProps: {
                          textContent: _vm._s(_vm.currentCategory.name)
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "close-button",
                          attrs: {
                            id: "close-category-modal",
                            tabindex: "0",
                            role: "button",
                            "aria-label": "Zamknij menu kategorii"
                          },
                          on: {
                            click: function($event) {
                              _vm.activeLayer = null
                            },
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                _vm.activeLayer = null
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                _vm.activeLayer = null
                              }
                            ]
                          }
                        },
                        [
                          _c("CloseIcon", {
                            attrs: { width: "30", "aria-hidden": "true" }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "categories-link",
                        attrs: {
                          href: _vm.currentCategory.url,
                          "aria-label": "Zobacz całą kategorię"
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Zobacz całą kategorię\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "categories-content",
                      attrs: { tabindex: "-1" }
                    },
                    _vm._l(_vm.currentCategoryChildren, function(category) {
                      return _c(
                        "li",
                        {
                          key: category.id,
                          staticClass: "category-list-element",
                          attrs: {
                            tabindex: "0",
                            "aria-label": "Kategoria:" + category.name,
                            role:
                              category.children && category.children.length > 0
                                ? "button"
                                : "link"
                          },
                          on: {
                            click: function($event) {
                              return _vm.goToCategory(category)
                            },
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.goToCategory(category)
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.goToCategory(category)
                              }
                            ]
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "category-title",
                            domProps: { textContent: _vm._s(category.name) }
                          }),
                          _vm._v(" "),
                          category.children && category.children.length > 0
                            ? _c("SortIcon", {
                                staticClass: "category-button",
                                attrs: { width: "24", "aria-hidden": "true" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ])
              ]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }